'use strict';

/*
    Firebase Tracking
    Listens to pageviews and events sent to GA
    and passes the data along to to Firebase handlers in our Mobile Apps

    NOTE: a modified copy of this file also exists in FS
    (see app/assets/javascripts/lib/firebase.js )
*/
function _Firebase() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};

  this.firebaseInit = function () {
    // called by _PortalPresenter

    function _logEvent(name, params) {
      if (!name) {
        return;
      }

      if (window.AnalyticsWebInterface) {
        // Call Android interface
        window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebase) {
        // Call iOS interface
        var message = {
          command: 'logEvent',
          name: name,
          parameters: params
        };
        window.webkit.messageHandlers.firebase.postMessage(message);
      } else {
        // No Android or iOS interface found
        console.log('No native APIs found.');
      }
    }

    var isWebView = window.AnalyticsWebInterface || window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebase;

    if (isWebView) {
      gaSpy({
        debug: false,
        debugLogPrefix: 'gaSpy',
        gaObjName: 'ga',
        // Function to call whenever `ga()` is called.
        callback: function callback(event) {
          try {
            if (event.the.hitType === 'pageview') {
              // get all the Pageview objects from the dataLayer
              var pageviewsObj = dataLayer.filter(function (obj) {
                return obj.event === 'DLevent.Pageview';
              });
              // get the Page string from the latest pageview object
              var lastPageview = pageviewsObj.slice(-1)[0].Page;
              // remove domain and cap at 100 chars
              var pathname = getLocation(lastPageview).pathname.substring(0, 99);
              _logEvent('screen_view', {
                screen_name: pathname
              });
            } else if (event.the.hitType === 'event') {
              _logEvent('mogo_ga_event', {
                category: event.args[1].eventCategory,
                action: event.args[1].eventAction,
                label: event.args[1].eventLabel
              });
            }
          } catch (e) {
            console.log('gaSpy callback failed');
          }
        }
      });
    }
  };
}